import { render, staticRenderFns } from "./MilestonesUpdate.vue?vue&type=template&id=2f90a5bb&"
import script from "./MilestonesUpdate.vue?vue&type=script&lang=js&"
export * from "./MilestonesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports